import { useSelector } from "react-redux";

import { useWithAnalytics } from "@stadium/services/analytics/hooks/use-with-analytics";
import { ANALYTICS_EVENT_ACTION_SELECTED } from "@stadium/services/analytics/constants/default";
import { getStoreNumber } from "@selectors/store";
import { SHOP_NAV_ANALYTICS_TARGET } from "@constants/analytics/shop";
import { ALL_SUBCATEGORY_CODE } from "@constants/routes";

/**
 * Hook to provide shared menu tracking logic across category navigation components.
 */
export const useMenuAnalytics = () => {
  const withAnalytics = useWithAnalytics();
  const storeNumber = useSelector(getStoreNumber);

  const trackMainCategory = (menuItem) => {
    if (menuItem?.id == null || storeNumber == null) return;
    withAnalytics(undefined, {
      track: true,
      target: SHOP_NAV_ANALYTICS_TARGET.CATEGORY,
      action: ANALYTICS_EVENT_ACTION_SELECTED,
      eventProperties: {
        shop_number: storeNumber,
        category_id: menuItem.id,
        category_code: menuItem.code,
        category_name: menuItem.name,
      },
    })();
  };

  const trackSubcategory = (parentItem, subItem) => {
    const isAllSubcategory = subItem?.code === ALL_SUBCATEGORY_CODE;
    if (parentItem?.id == null || storeNumber == null || (!isAllSubcategory && subItem?.id == null))
      return;
    withAnalytics(undefined, {
      track: true,
      target: SHOP_NAV_ANALYTICS_TARGET.SUBCATEGORY,
      action: ANALYTICS_EVENT_ACTION_SELECTED,
      eventProperties: {
        shop_number: storeNumber,
        category_id: parentItem.id,
        category_code: parentItem.code,
        category_name: parentItem.name,
        subcategory_id: isAllSubcategory ? undefined : subItem.id,
        subcategory_code: subItem.code,
        subcategory_name: subItem.name,
      },
    })();
  };

  return { trackMainCategory, trackSubcategory };
};
